import type { IconNode } from '../types';

/**
 * @name bottle-toothbrush-comb
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiB4PSIyIiB5PSIzIiAvPgogIDxwYXRoIGQ9Ik02IDd2MmMwIC42LjEgMS40LjIgMkw4IDIwLjh2LjJjMCAuNi0uNCAxLTEgMUgzYy0uNiAwLTEtLjQtMS0xVjciIC8+CiAgPHBhdGggZD0iTTE0IDJ2N2wtMiA1djgiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNiIgeD0iMTAiIHk9IjMiIC8+CiAgPHBhdGggZD0iTTE4IDZoNCIgLz4KICA8cGF0aCBkPSJNMTggMTBoNCIgLz4KICA8cGF0aCBkPSJNMTggMTRoNCIgLz4KICA8cGF0aCBkPSJNMTggMThoNCIgLz4KICA8cGF0aCBkPSJNMTggMmgyYTIgMiAwIDAgMSAyIDJ2MTZhMiAyIDAgMCAxLTIgMmgtMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bottle-toothbrush-comb
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottleToothbrushComb: IconNode = [
  ['rect', { width: '4', height: '4', x: '2', y: '3', key: '15h8vi' }],
  [
    'path',
    { d: 'M6 7v2c0 .6.1 1.4.2 2L8 20.8v.2c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7', key: '1hwq08' },
  ],
  ['path', { d: 'M14 2v7l-2 5v8', key: '1imhrc' }],
  ['rect', { width: '4', height: '6', x: '10', y: '3', key: 'b6kk5p' }],
  ['path', { d: 'M18 6h4', key: '66u95g' }],
  ['path', { d: 'M18 10h4', key: '1fqhjb' }],
  ['path', { d: 'M18 14h4', key: '16spdh' }],
  ['path', { d: 'M18 18h4', key: '187mio' }],
  ['path', { d: 'M18 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2', key: 'ab8lh9' }],
];

export default bottleToothbrushComb;
